import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import BaseAnswer from '../base-answer';
import { AnswerProvider, FeedbackAnswerSurvey } from '../../providers/answer-provider';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FeedbackQuestionSurvey } from '../../providers/question-provider';
import { FeedbackQuestionFactoryService } from '../../questions/feedback-question-factory.service';
import { FeedbackQuestionService } from '../../questions/feedback-question.service';
import { MatFormField, MatFormFieldModule } from "@angular/material/form-field";
import { TranslateModule } from "@ngx-translate/core";
import { MatInput, MatInputModule } from "@angular/material/input";
import { NgForOf } from "@angular/common";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { FlexLayoutModule } from "@angular/flex-layout";
import { Feedback } from "../../../common/models/feedback";

@Component({
  selector: 'app-feedback-remark-answer',
  templateUrl: 'feedback-remark-answer.component.html',
  styleUrls: ['./../feedback-answer.css', 'feedback-remark-answer.css'],
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    TranslateModule,
    MatInputModule,
    NgForOf,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule,

  ],
  standalone: true
})
export class FeedbackRemarkAnswerComponent extends BaseAnswer implements OnInit {
    @Input()
    public override hasAnsweredQuestion = false;

    @Input()
    public override feedback: Feedback = {} as Feedback;

    @Input()
    public override question: FeedbackQuestionSurvey = {} as FeedbackQuestionSurvey;

    @Input()
    public override previousAnswers: any = null;

    @Input()
    public answeredAnswers: any = null;

    @Output()
    public override onAnswerChange: EventEmitter<any> = new EventEmitter();

    @Output()
    public override onNextQuestionClicked: EventEmitter<{answers: FeedbackAnswerSurvey[]; isBack: boolean}> = new EventEmitter();

    public remark = '';

    public form: FormGroup;

    public selectedAnswer: any = null;

    constructor(
        protected override answerProvider: AnswerProvider,
        protected override feedbackQuestionFactoryService: FeedbackQuestionFactoryService,
        protected override feedbackQuestionService: FeedbackQuestionService,
        private fb: FormBuilder
    ) {
        super(answerProvider, feedbackQuestionFactoryService, feedbackQuestionService);

        this.form = this.fb.group({
            remark: new FormControl(null),
        });
    }

    public override ngOnInit(): void {
        super.ngOnInit();

        // find all answers for this question
        const data: any = this.feedbackQuestionService.getAnsweredAnswersByQuestionId(this.question['id']);
        this.selectedAnswer = data && data['answers'].length > 0 ? data['answers'][0] : null;

        if (this.selectedAnswer) {
            this.remark = this.selectedAnswer.userData ? this.selectedAnswer.userData : '';

            this.answerChanged(this.selectedAnswer);
        }
    }
}
